
<ng-container *transloco="let t">
    <div *ngIf="isTeam && competitor?.raceCommercialItem"
         class="d-flex flex-column" [ngClass]="!isMobile ? 'section light-grey m-12 p-12' : 'section-header light-grey p-12'">
            <p class="fw-400 color-slate-600 fs-14">{{ t('my.tracey.order.team.registration.fee') }}:
                <app-language-output [hrLabel]="competitor!.raceCommercialItem!.name"
                                     [enLabel]="competitor!.raceCommercialItem!.nameEng"
                                     [itLabel]="competitor!.raceCommercialItem!.nameIta"
                                     [siLabel]="competitor!.raceCommercialItem!.nameSlo"
                                     [srLabel]="competitor!.raceCommercialItem!.nameSr"
                                     [bsLabel]="competitor!.raceCommercialItem!.nameBs"
                                     [languages]="languages"/>
            </p>
            <div class="d-flex justify-content-between align-items-center">
                <p class="fw-400 color-slate-600 fs-14">
                    {{ t('my.tracey.order.qty')}}
                    {{1}} x
                    {{ (competitor!.raceCommercialItem!.priceWithDiscount ?? 0)| myCurrency:currencyCode:true}}
                </p>
                <p class="fw-semibold">
                    {{(competitor!.raceCommercialItem!.priceWithDiscount ?? 0)|myCurrency:currencyCode:true}}
                </p>
            </div>
    </div>
    <div *ngFor="let displayCompetitor of displayCompetitors; let i = index, let isLast = last" class="p-12">
        <div [ngClass]="!isTeam ? 'divider-horizontal' : ''"></div>
        <div class="d-flex flex-column">
            <div class="d-flex flex-column flex-grow-1 gap-2">
                <p class="fw-semibold">{{ displayCompetitor.firstName }} {{displayCompetitor.lastName}}</p>
                <div *ngIf="displayCompetitor.raceCommercialItem">
                    <p class="fw-400 color-slate-600 fs-14">{{ t('my.tracey.order.individual.registration') }}:
                        <app-language-output [hrLabel]="displayCompetitor.raceCommercialItem.name"
                                             [enLabel]="displayCompetitor.raceCommercialItem.nameEng"
                                             [itLabel]="displayCompetitor.raceCommercialItem.nameIta"
                                             [siLabel]="displayCompetitor.raceCommercialItem.nameSlo"
                                             [srLabel]="displayCompetitor.raceCommercialItem.nameSr"
                                             [bsLabel]="displayCompetitor.raceCommercialItem.nameBs"
                                             [languages]="languages"/>
                    </p>
                    <div class="d-flex justify-content-between align-items-center flex-grow-1">
                        <p class="fw-400 color-slate-600 fs-14">
                            {{ t('my.tracey.order.qty')}}
                            x
                            {{1}}
                            {{
                            (displayCompetitor!.raceCommercialItem!.priceWithDiscount ?? 0) |
                                myCurrency:currencyCode:true
                            }}
                        </p>
                        <p class="fw-semibold">
                            {{
                            (displayCompetitor!.raceCommercialItem!.priceWithDiscount ?? 0) |
                                myCurrency:currencyCode:true
                            }}
                        </p>
                    </div>
                </div>

                <div *ngIf="displayCompetitor.raceAdditionalPricingItems?.length">
                    <div class="d-flex flex-column gap-1">
                        <div [ngClass]="!isMobile ? 'divider-horizontal' : ''"></div>
                        <p class="fw-semibold fs-14">{{ t('my.tracey.order.extras') }}</p>
                        <div class="d-flex flex-column gap-1" [ngClass]="isMobile ? '' : 'section light-grey p-16'">
                            <div *ngFor="let additional of displayCompetitor.raceAdditionalPricingItems!.slice(0, dropdownOpened.get(i) ? displayCompetitor.raceAdditionalPricingItems!.length : EXPANDABLE_BREAKPOINT); let addIdx = index">
                                <div class="d-flex justify-content-between align-items-center">
                                    <p class="fw-400 color-slate-600 fs-14">
                                        <app-language-output [hrLabel]="additional.name"
                                                             [enLabel]="additional.nameEng"
                                                             [itLabel]="additional.nameIta"
                                                             [siLabel]="additional.nameSlo"
                                                             [srLabel]="additional.nameSr"
                                                             [bsLabel]="additional.nameBs"
                                                             [languages]="languages"/>
                                        <span *ngIf="additional.pricingItemValues?.length">
                                  :  <app-language-output [hrLabel]="additional.pricingItemValues![0].name"
                                                          [enLabel]="additional.pricingItemValues![0].nameEng"
                                                          [itLabel]="additional.pricingItemValues![0].nameIta"
                                                          [siLabel]="additional.pricingItemValues![0].nameSlo"
                                                          [srLabel]="additional.pricingItemValues![0].nameSr"
                                                          [bsLabel]="additional.pricingItemValues![0].nameBs"
                                                          [languages]="languages"/>
                                </span>

                                    </p>
                                    <p class="fw-semibold fs-14">
                                        {{ additional.priceWithDiscount | myCurrency:currencyCode:true }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="displayCompetitor.raceAdditionalPricingItems!.length > EXPANDABLE_BREAKPOINT" class="d-flex justify-content-center align-items-center gap-2 color-teal-500 cursor-pointer"
                             (click)="toggleDropdown(i)">
                            <p class="fw-500 fs-14"> {{ dropdownOpened.get(i) ?
                                t('my.tracey.order.show.less') : t('my.tracey.order.show.more', {number: displayCompetitor.raceAdditionalPricingItems!.length - EXPANDABLE_BREAKPOINT})
                                }}</p>
                            <i class="bi fs-18 chevron-icon"
                               [class.rotated]="dropdownOpened.get(i)"
                               [ngClass]="'bi-chevron-down'"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div [ngClass]="!isLast && !isTeam ? 'divider-horizontal' : ''"></div>
    </div>
</ng-container>
